import WarrantyFormArchSelection from '../Fields/WarrantyFormArchSelection';
import WarrantyFormConditionalFit from '../Fields/WarrantyFormConditionalFit';
import WarrantyFormUserIssue from '../Fields/WarrantyFormUserIssue';

function StepTwo() {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="font-bold text-gray-900 text-xl leading-6">
          Issue Details
        </h3>
        <p className="mt-1 text-gray-500 text-sm">
          Describe what&apos;s wrong with your retainer
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 text-left sm:grid-cols-1">
        {/* User Issue Dropdown */}
        <WarrantyFormUserIssue />

        {/* Arch Selection Dropdown */}
        <WarrantyFormArchSelection />

        {/* Conditional Fit Dropdowns */}
        <WarrantyFormConditionalFit />
      </div>
    </div>
  );
}

export default StepTwo;
